import Components from "./Components";

import customValidations from './Form.validations';

export default class Form {
	constructor(el, rules, callback) {
		this.form = $(el).find('form').first();
		this.rules = rules;
		this.approve = require('approvejs');
		this.errors = [];
		this.scroolToError = true;

		this.form.submit(() => {
			var submit = false;
			this.scroolToError = true;
			if (this.validation()) {
				if(typeof callback === 'function') {
					if(this.form.data('callback') === false) {
						submit = true;
					} else {
						callback(this.form);
					}
				} else {
					submit =  true;
				}
			}
			return submit;
		});

		/*this.form.on('change input', 'input, select, textarea', () => {
			this.scroolToError = false;
			this.validation()
		});*/

		for (var key in customValidations) {
			this.approve.addTest(customValidations[key], key)
		}

		if ( this.form.find('.sl-errors label.sl-error').length ) {
			this.scrollToErrors();
		}
		this.changeClass();
	}

	validation() {

		if(this.form.data('validation') == 'validated') {
			return true;
		}

		this.errors = [];
		this.rules.forEach((rule, index) => {
			this.validate(rule);
		});

		this.form.find('.sl-required').each((key,value) => {
			if($(value).is('input')) {
				this.validate({
					'name': $(value).attr('name'),
					'rules': {
						required: {
							message: 'Preencha todos os campos obrigatorios.',
						}
					}
				});
			}
		});

		this.showErrors();
		this.changeClass();
		if (this.errors.length == 0) {
			return true;
		}
		return false;
	}

	validate(rule) {
		if(this.checkIfFieldIsValid(rule)) {
			if(this.form.find('[name="'+rule.name+'"]:visible').attr('type') == 'radio') {
				var val = this.form.find('[name="'+rule.name+'"]:visible:checked').val();
			} else {
				var val = this.form.find('[name="'+rule.name+'"]').val();
			}

			if("equal" in rule.rules) {
				rule.rules.equal.value = this.form.find(rule.rules.equal.select).val()
			}

			var result = this.approve.value(val, rule.rules);
			if (!result.approved) {
				this.errors.push({
					'name': rule.name,
					'errors': result.errors
				});
			}
		}
	}

	showErrors() {
		if(!this.hasErrors()) {
			this.form.find('.sl-errors').fadeOut(200, () => {
				this.form.find('.sl-errors').remove();
			});
			return;
		}
		var html = '';
		this.errors.forEach((field, index) => {
			var errors_html = '';
			field.errors.forEach((error, index) => {
				errors_html += `<label class="sl-error">${error}</label>`;
			});
			html += `<div class="sl-field">${errors_html}</div>`;
		});

		if(this.form.find('.sl-errors').length == 0) {
			let errorHTML = '<div class="sl-errors"><h4>Encontramos alguns erros!</h4><div class="sl-errors-inner"></div></div>';
			if ( this.form.find('.sl-errors-container').length != 0 ) {
				this.form.find('.sl-errors-container').html(errorHTML)
			}
			else {
				this.form.prepend(errorHTML);
			}
		}
		this.form.find('.sl-errors .sl-errors-inner').html(html);
		this.form.find('.sl-errors').fadeIn();
		this.scrollToErrors();
	}

	scrollToErrors() {
		if ( this.scroolToError == false ) {
			return
		}
		$("html, body").animate({ scrollTop: this.form.find('.sl-errors').offset().top-45 }, "slow");
	}

	hasErrors() {
		return this.errors.length > 0;
	}

	checkIfFieldIsValid(rule) {
		const field = this.form.find('[name="'+rule.name+'"]');

		if(field.is('[type="hidden"]')) {
			return true;
		}

		if(!field.is(':visible')) {
			return false;
		}

		return true;
	}

	changeClass() {
		this.form.removeClass('sl-form-valid').removeClass('sl-form-invalid').addClass(this.hasErrors() ? 'sl-form-invalid':'sl-form-valid');
	}

	static cep(el) {
		// Autocompletar com CEP
		$('#cep').on('keyup', function () {
			let cep = this.value.replace(/\W/g, '');
			if(cep.length !== 8) {
				return;
			}
			Components.loading(el);
			$.ajax({
				method: "POST",
				url: wp.ajax_url,
				data: {
					action: 'sl_cep',
					data: {
						cep,
					},
				}
			}).done(data => {
				Components.loading(el, 'stop');
				$('#estado').val(data.uf);
				$('#cidade').val(data.localidade);
				$('#bairro').val(data.bairro);
				$('#rua').val(data.logradouro);
			});
		});
	}
}
